import * as S from "./mainProfileImg.styles";
import { ReactComponent as IconProfile } from "../../../styles/assets/svg/icon-profile-noimage.svg";
import { px } from "framer-motion";

type MainProfileImgProps = {
  width?: number;
  height?: number;
};

export const MainProfileImg = ({ width, height }: MainProfileImgProps) => {
  return (
    <S.MainProfileImgBox width={width} height={height}>
      <IconProfile width={width} height={height} />
    </S.MainProfileImgBox>
  );
};
